import React, { useState } from 'react'
import './JobDetail.css'
import TabJobDetail from './TabJobDetail';
import TabBusinessResponse from './TabBusinessResponse';
import { Provider } from "../JobOnboarding/MultiStepFormContext";
import { useLocation } from 'react-router-dom';
import DashboardNavbar from '../../components/Navbar/navbar-dashboard';
import Footer from '../../components/Footer/footer';

const detailsInitialState = {
  title: "",
  postcode: "",
  description: "",
};

const timeBudgetInitialState = {
  budget: "",
  budgettype: "",
  jobtime: "",
  visittime: "",
};

const mediaInitialState = [null, null, null, null];

const JobDetail = () =>
{

  const [selectedTab, setSelectedTab] = useState(1);
  const [details, setDetails] = useState(detailsInitialState);
  const [timeBudget, setTimeBudget] = useState(timeBudgetInitialState);
  const [uploadedImages, setUploadedImages] = useState(mediaInitialState);
  const [isPopup, setIsPopup] = useState(false);
  const location = useLocation();
  const { jobId } = location.state || {};
  const { duplicate } = location.state || {};
  const [jobID, setJobID] = useState(jobId);


  const handleTabClick = (tabIndex) =>
  {
    setSelectedTab(tabIndex);
  };

  return (
    <div>
      <DashboardNavbar prefix='' />
      <div className="main-section">
        <section class="inner-page-banner">
          <div class="container">
            <div class="row">
              <h1 class="banner-heading">JOB DETAILS</h1>
            </div>
            <div class="row justify-content-center">

              {/* <div className={`add_button_text2 btn  d-lg-table tab ${selectedTab === 1 ? 'selected' : ''}`} onClick={() => handleTabClick(1)}>
                Job Details
              </div> */}
              {/* <div className={`add_button_text2 btn  d-lg-table tab ${selectedTab === 2 ? 'selected' : ''}`} onClick={() => handleTabClick(2)} >
                Businesses Repsonses
              </div> */}
            </div>

          </div>
        </section>

        <div className="header-section2 bottom-hammer-vector">

          <Provider
            value={{
              details,
              setDetails,
              timeBudget,
              setTimeBudget,
              uploadedImages,
              setUploadedImages,
              isPopup,
              setIsPopup,
            }}
          >
            <div className={`${selectedTab === 1 ? 'slide-left' : 'slide-right'}`}>
              {selectedTab === 1 ? <TabJobDetail jobId={jobId} duplicate={duplicate} /> : <TabBusinessResponse jobId={jobID} duplicate={duplicate} />}
            </div>
          </Provider>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default JobDetail
